import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { createContext, Children, isValidElement, cloneElement } from 'react';
import { css } from '@styled-system/css';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var buttonsStyles = function buttonsStyles(isStacked) {
  if (isStacked) {
    return {
      "button:not(:first-child)": {
        marginTop: -1,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      "button:not(:last-child)": {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    };
  }

  return {
    "button:not(:first-child)": {
      marginLeft: -1,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    "button:not(:last-child)": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }
  };
};

var StyledToggleButtonGroup = styled(Box).withConfig({
  componentId: "sc-7klh2w-0"
})(function (props) {
  return css(__spreadValues({
    width: props.isFull ? "100%" : "auto",
    display: "flex",
    flexDirection: props.isStacked ? "column" : "row",
    button: {
      flex: "1 1 auto"
    }
  }, buttonsStyles(props.isStacked)));
});
var ToggleButtonGroupContext =
/*#__PURE__*/
createContext({
  value: void 0
});
var ToggleButtonGroup = forwardRef(function (_a, ref) {
  var _b = _a,
      children = _b.children,
      onChange = _b.onChange,
      value = _b.value,
      size = _b.size,
      _b$isRounded = _b.isRounded,
      isRounded = _b$isRounded === void 0 ? false : _b$isRounded,
      _b$isFull = _b.isFull,
      isFull = _b$isFull === void 0 ? false : _b$isFull,
      _b$isStacked = _b.isStacked,
      isStacked = _b$isStacked === void 0 ? false : _b$isStacked,
      isDisabled = _b.isDisabled,
      props = __objRest(_b, ["children", "onChange", "value", "size", "isRounded", "isFull", "isStacked", "isDisabled"]);

  var handleChange = function handleChange(event, value2) {
    onChange == null ? void 0 : onChange(event, value2);
  };

  return (
    /* @__PURE__ */
    React.createElement(ToggleButtonGroupContext.Provider, {
      value: {
        value: value
      }
    },
    /* @__PURE__ */
    React.createElement(StyledToggleButtonGroup, __spreadValues({
      ref: ref,
      isFull: isFull,
      isStacked: isStacked
    }, props), Children.map(children, function (child) {
      if (!
      /*#__PURE__*/
      isValidElement(child)) {
        return null;
      }

      return (
        /*#__PURE__*/
        cloneElement(child, {
          size: child.props.size || size,
          isRounded: child.props.isRounded || isRounded,
          isDisabled: child.props.isDisabled || isDisabled,
          onChange: handleChange
        })
      );
    })))
  );
});
ToggleButtonGroup.displayName = "ToggleButtonGroup";
export { ToggleButtonGroup, ToggleButtonGroupContext };